import {
  createUseInvokeClient,
  IndieTabletopClient,
} from "@indietabletop/appkit";
import { gangSnapshotData } from "@indietabletop/types";
import { unknown } from "superstruct";
import { config } from "./config.ts";

export class SpaceGitsClient extends IndieTabletopClient {
  async getSpaceGitsUnlocks() {
    return await this.getUnlocks("spacegits");
  }

  async getSharedGang(gangId: string) {
    return await this.getSnapshot("spacegits", gangId);
  }
}

export const client = new SpaceGitsClient({
  apiOrigin: config.VITE_ITC_API_ORIGIN,
  validation: {
    ruleset: unknown(),
    gameData: unknown(),
    snapshot: gangSnapshotData(),
  },
});

export const useInvokeClient = createUseInvokeClient(client);
